import { TITLE_PREFIX, SHOW_TITLE_PREFIX } from '../../config'

function getTitle (vm) {
  const { title } = vm.$options
  if (title) {
    return typeof title === 'function' ? title.call(vm) : title
  }
}

export default {
  created () {
    if (this.$route && this.$route.meta && this.$route.meta.pageTitle) {
      document.title = `${SHOW_TITLE_PREFIX ? `${TITLE_PREFIX} | ` : ''}${this.$route.meta.pageTitle}`
    } else {
      const title = getTitle(this)
      if (title) {
        document.title = title
      }
    }
  }
}
